import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/production/calcul-besoins")({
  staticData: {
    permission: PERMISSIONS.PRODUCTION.CBNSAD.VIEW,
  },
  component: () => <Outlet />,
});
